const UA = navigator.userAgent || '';

const getChromeVersion = () => {
  const ary = navigator.userAgent.match(/.+Chrome\/(\d+).+Safari\/(\d+).*/i);
  if (!ary) return null;
  return +ary[1] || null;
};

const getiOSVersion = () => {
  const ary = navigator.userAgent.match(/.+Version\/(\d+).*/i);
  if (!ary) return null;
  return +ary[1] || null;
};

const browser = {
  isAlipay: /alipay|aliapp|alipayclient/i.test(UA),
  isQQbrw: UA.indexOf('MQQBrowser') > -1 || UA.indexOf('QQBrowser') > -1, // QQ浏览器
  isAndroid: !!UA.match(/Android|Adr/i),
  isIOS: !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i) || !!UA.match(/\(Maci[^;]+; .+Mac OS X/i),
  isSafari: /iPhone|iPad|iPod\/([\w.]+).*(safari).*/i.test(UA),
  isQQ: /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d\.]+)/.test(UA) || /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/.test(UA),
  // 微信
  isWx: !!UA.match(/micromessenger/i),
  isPcWx: !!UA.match(/WindowsWechat/i),
  // 微博
  isWb: !!UA.match(/weibo/i),
  isQZ: !!UA.match(/Qzone/i),
  isOxygen: /(oxygen|caramel|callme)/.test(UA),
  isCaramel: UA.indexOf('caramel') !== -1,
  isCallme: UA.indexOf('callme') !== -1,
  isHydrogen: /hydrogen[^P]/.test(UA),
  isYoyo: UA.indexOf('yoyo') !== -1,
  isOxPC: UA.indexOf('PCMiz') !== -1,
  isHydrogenPC: UA.indexOf('hydrogenPc') !== -1,
  chromeVersion: getChromeVersion(),
  iOSVersion: getiOSVersion(),
};

/**
 * 判断浏览器是否支持webp
 * return { Boolean } true 支持， false 不支持
 */
const isSupportWebp = (function () {
  let featureKey = 'browser-webp-supported';
  if (Number(localStorage.getItem(featureKey)) === 1) {
    return true;
  }

  // 代码来源淘宝
  let flag = !![].map && document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0;
  if (flag) {
    localStorage.setItem(featureKey, '1');
  }

  return flag;
})();

export { browser, isSupportWebp };
